import { cn } from '@quadralize/utils'
import { type HTMLMotionProps, motion } from 'framer-motion'
import * as React from 'react'

const spinnerVariants = {
  initial: { opacity: 0, scale: 0.8 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.8 },
}

interface SpinnerProps extends HTMLMotionProps<'div'> {
  size?: 'sm' | 'md' | 'lg'
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size = 'md', ...props }, ref) => {
    const sizeClasses = {
      sm: 'h-4 w-4 border-2',
      md: 'h-6 w-6 border-2',
      lg: 'h-8 w-8 border-3',
    }

    return (
      <motion.div
        ref={ref}
        initial="initial"
        animate="animate"
        exit="exit"
        variants={spinnerVariants}
        className={cn('flex items-center justify-center', className)}
        {...props}
      >
        <div
          className={cn(
            'animate-spin rounded-full border-current border-t-transparent',
            sizeClasses[size],
          )}
        />
      </motion.div>
    )
  },
)

Spinner.displayName = 'Spinner'

export { Spinner }
